import UnifiedSearchableSelect from './UnifiedSearchableSelect';
import type { UnifiedSearchableSelectOption } from './UnifiedSearchableSelect';

export type SearchableSelectOption = UnifiedSearchableSelectOption;

type SearchableSelectProps = {
  options: SearchableSelectOption[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  searchPlaceholder?: string;
  noResultsText?: string;
  id?: string;
  disabled?: boolean;
};

const SearchableSelect = ({
  options,
  value,
  onChange,
  placeholder = '',
  searchPlaceholder = '',
  noResultsText = '',
  id,
  disabled = false,
}: SearchableSelectProps) => (
  <UnifiedSearchableSelect
    id={id ?? 'searchable-select'}
    options={options}
    multiple={false}
    searchable
    disabled={disabled}
    placeholder={placeholder}
    searchPlaceholder={searchPlaceholder}
    noResultsText={noResultsText}
    value={value}
    onChange={onChange}
  />
);

export default SearchableSelect;
